interface ErrorStateProps {
  message: string;
}

const ErrorState = ({ message }: ErrorStateProps) => (
  <div className="status full-screen error">
    <p>⚠️ {message}</p>
    <p className="footnote">Refresh or try again in a few minutes.</p>
  </div>
);

export default ErrorState;
